function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function NoiceIcon(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 128 128",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M103.54 16.4945C99.731 17.1723 97.9822 19.7326 97.9822 28.181C97.9822 79.3125 86.5673 92.9508 80.4033 92.9508C76.2543 92.9508 74.7962 89.2513 74.3375 87.4506C74.276 87.1321 74.2146 86.8136 74.1532 86.4869C69.4267 60.1576 71.5688 15 47.6783 15C13.4666 15 0.364346 87.8589 -0.000174836 105.376C-0.0738981 108.851 2.15009 112.04 5.66013 112.812C9.07188 113.559 12.4509 111.775 13.8147 108.712C14.0113 108.267 27.4945 67.5157 40.8425 67.5157C58.4173 67.5157 57.1722 113 81.2838 113C87.2022 113 93.3253 109.95 101.128 102.33C103.958 99.5658 106.796 96.1889 109.553 92.126C124.117 70.6763 127.856 51.8888 127.992 40.0063C128.151 26.2333 112.624 14.8857 103.536 16.4945H103.54Z"
        })
    }));
}
